import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle, CmsCollection, CmsTaxonomyGeneral } from '@fcom/core-api/interfaces/cms-interface';
import { isNotEmpty } from '@fcom/core/utils/utils';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { IconPosition } from '@fcom/ui-components/components/icons/enums';

@Component({
  selector: 'cms-discover-now',
  styleUrls: ['./cms-discover-now.component.scss'],
  templateUrl: './cms-discover-now.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsDiscoverNowComponent {
  private readonly themeService = inject(FinnairThemeService);

  public readonly SvgLibraryIcon: typeof SvgLibraryIcon = SvgLibraryIcon;
  public readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  public readonly IconPosition: typeof IconPosition = IconPosition;

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  content = input.required<CmsCollection>();

  items = computed<CmsArticle[] | undefined>(() => {
    const items = this.content().items as CmsArticle[];
    return isNotEmpty(items) ? items : undefined;
  });
  subjectTaxonomyTags = computed<string[]>(() => this.content().subjectTaxonomyTags || []);
  text = computed<string | undefined>(() => this.content().teaserText);
  title = computed<string | undefined>(() => this.content().teaserTitle);
}
